import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { RouterModule } from '@angular/router'

import { TooltipModule } from 'primeng/tooltip'

import { FlxIconModule, FlxMessageModule } from '@flowx/angular-ui-toolkit'
import { FX_ORGANIZATION_CODE_TOKEN } from '@flowx/designer/modules/auth/auth.constants'
import { TOOLTIP_DEFAULT_DELAY } from '@flowx/designer/modules/core/dictionary/constants'
import { FlxNavMenuComponent } from '@flowx/designer/modules/layout/components/nav-menu/nav-menu.component'
import { PlatformStatusService } from '@flowx/designer/modules/platform-status/platform-status.service'
import { WorkspacesSwitchComponent } from '@flowx/designer/modules/workspaces/shared/workspaces-switch/workspaces-switch.component'
import { WorkspacesAndPermissionsStore } from '@flowx/designer/modules/workspaces/workspaces-and-permissions.store'

import { NavMenuStore } from '../nav-menu/nav-menu.store'

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  host: { class: 'w-full h-screen' },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    WorkspacesSwitchComponent,
    FlxMessageModule,
    FlxIconModule,
    RouterModule,
    FlxNavMenuComponent,
    TooltipModule,
  ],
})
export class MainLayoutComponent {
  #workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  #navMenuStore = inject(NavMenuStore)
  organizationCode = inject(FX_ORGANIZATION_CODE_TOKEN)

  readonly TOOLTIP_DEFAULT_DELAY = TOOLTIP_DEFAULT_DELAY

  selectedWorkspace = this.#workspacesAndPermissionsStore.selectedWorkspace
  isOrganizationAdminWorkspace = this.#workspacesAndPermissionsStore.isOrganizationAdminWorkspace

  permissions = this.#workspacesAndPermissionsStore.userAndWorkspacePermissions
  userAccessRights = this.#workspacesAndPermissionsStore.userAccessRights
  platformStatusService = inject(PlatformStatusService)

  someComponentsAreDown = computed(() => this.platformStatusService.downComponents().length > 0)
  firstDownComponent = computed(() => this.platformStatusService.downComponents()[0] ?? null)

  canReadPlatformStatus = computed(() => {
    const permissions = this.permissions()
    const isOrganizationAdminWorkspace = this.isOrganizationAdminWorkspace()

    return isOrganizationAdminWorkspace
      ? permissions['org_platform_status_read']
      : permissions['wks_platform_status_read']
  })

  navMenuItems = this.#navMenuStore.navMenuItems
}
